import { Languages } from '@/common/utils/constants';
import { MembershipTypeSectionItemsInterface } from '@/widgets/BecomeAMember/components/Receipt/components/MembershipTypeSection/MembershipTypeSection.types';
import ReceiptDetailsTitleSection from '@/widgets/BecomeAMember/components/Receipt/components/common/ReceiptDetailsTitleSection/ReceiptDetailsTitleSection';
import { calculateIncreasedDate } from '@/widgets/BecomeAMember/components/Receipt/utils/calculateIncreasedDate';
import { formatDate } from '@/widgets/BecomeAMember/components/Receipt/utils/formatDate';
import { formatPrice } from '@/common/utils/formatPriceForDisplay';

const ACTUAL_BONUS_PRICE = '0';

interface BonusPeriodProps extends MembershipTypeSectionItemsInterface {
  lang: Languages;
}

export default function BonusPeriod({
  translations,
  voucherData,
  currency,
  priceDecimalSeparator = '.',
  lang,
  startDate,
  rowMembershipPeriodDate,
}: BonusPeriodProps) {
  if (!voucherData?.voucher_bonus_period) return;

  const oldBonusPrice = (() => {
    if (voucherData.voucher_type === 'COMPANY_FEE_SPLIT') {
      return formatPrice(voucherData.discounted_base_price ?? '0', priceDecimalSeparator);
    }

    return formatPrice(voucherData?.base_price ?? '0', priceDecimalSeparator);
  })();

  const rowStartBonusDate = (() => {
    if (
      voucherData?.voucher_bonus_period?.term_strategy === 'END_OF_CURRENT_TERM'
    ) {
      return rowMembershipPeriodDate;
    }
    return startDate;
  })();

  const startBonusDate = formatDate(new Date(rowStartBonusDate ?? ''), lang);

  const endRowBonusDate = calculateIncreasedDate({
    amount: voucherData?.voucher_bonus_period?.term?.value ?? 0,
    unit: voucherData?.voucher_bonus_period?.term?.unit ?? '',
    startDate: new Date(rowStartBonusDate ?? ''),
  });
  const endBonusDate = formatDate(endRowBonusDate, lang);

  return (
    <ReceiptDetailsTitleSection
      title={translations['becomeamember.floatingreceipt.bonusperiod']}
      currency={currency}
      price={ACTUAL_BONUS_PRICE}
      oldPrice={oldBonusPrice}
      additionalText={`${startBonusDate} - ${endBonusDate} `}
    />
  );
}
